// extracted by mini-css-extract-plugin
export default {"wrapper":"FilesUpload_wrapper__XiUPZ","isDragActive":"FilesUpload_isDragActive__b3F8m"};